import { useEffect, useReducer } from "react";
import { shallowEqual, useSelector } from "react-redux";
import type { RootState } from "@/redux/store";
import { selectSupportAccount, type SupportAccountType } from "./supportAccount";

export const useSupportAccount = (accountType?: SupportAccountType) => {
  const [, refreshPreference] = useReducer((revision: number) => revision + 1, 0);

  useEffect(() => {
    if (accountType) return;
    const handleStorage = (event: StorageEvent) => {
      if (event.key === "accountType" || event.key === null) refreshPreference();
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [accountType]);

  // A storage event rerenders this hook and supplies a fresh selector, so the
  // preferred account is reevaluated even when Redux itself has not changed.
  return useSelector(
    (state: RootState) => selectSupportAccount(state, accountType),
    shallowEqual,
  );
};
